@if ((isHovered || isSelected) && isSelectable) {
  <rt-checkbox [checked]="isSelected" (click)="select.emit(record)" class="selection-checkbox" />
}

<div class="main-content">
  <div class="header">
    @if (fieldsVisibilityMap.title) {
      <a [href]="jobUrl">
        <rt-heading class="title" [textWrap]="true">
          @if (!isStatusGrouping) {
            <rt-offer-status-indicator [offerStatus]="record" margin-right-small-xx />
          }
          {{ record.title }}
        </rt-heading>
      </a>
    }
    @if (fieldsVisibilityMap.job_id) {
      <rt-badge
        [text]="'#' + record.guid"
        [rtClickToCopy]="record.guid"
        [rtTooltip]="'app.offer.copy_id' | translate"
        color="secondary"
      />
    }
  </div>
  <div class="second-row">
    @if (fieldsVisibilityMap.department && record.department) {
      <span
        #elRef
        [rtTooltip]="record.department"
        [rtTooltipEnabled]="isTruncatedFactory | fnCall: elRef"
        class="department overflow-hidden"
        [class.max-width]="fieldsVisibilityMap.location && locationIds.length"
      >
        {{ record.department }}
      </span>
    }
    @if (fieldsVisibilityMap.location && locationIds.length) {
      @if (fieldsVisibilityMap.department && record.department) {
        <rt-divider variant="dot" />
      }
      <span class="location overflow-hidden">
        <rt-assigned-locations-info-container
          [locationIds]="locationIds"
          [tooltipPosition]="'above'"
        />
      </span>
    }
    @if (fieldsVisibilityMap.priority && record.priority) {
      @if (hasElementsBeforePriority) {
        <rt-divider variant="dot" />
      }
      <span>
        <rt-icon [name]="'flag'" [colorToken]="priorityIconColorToken" />
      </span>
    }
  </div>
  <div class="third-row">
    @if (fieldsVisibilityMap.work_model && workModelLabel) {
      <span
        #elRef
        [rtTooltip]="workModelLabel"
        [rtTooltipEnabled]="isTruncatedFactory | fnCall: elRef"
        class="work-model overflow-hidden"
      >
        {{ workModelLabel }}
      </span>
    }
  </div>
</div>
<rt-divider margin-tb-small-x />
<div class="counters">
  @if (fieldsVisibilityMap.qualified_candidates) {
    <div class="counter">
      <span text-bold margin-right-small-xxx>{{ record.qualifiedCandidatesCount }}</span>
      {{ 'app.views_jobs.board_card.qualified' | translate }}
    </div>
  }
  @if (fieldsVisibilityMap.new_candidates && newCandidatesLabel) {
    <rt-badge color="info" [text]="newCandidatesLabel" />
  }
  @if (fieldsVisibilityMap.disqualified_candidates && record.disqualifiedCandidatesCount) {
    <div class="counter">
      <rt-icon name="block" margin-right-small-xx />
      {{ record.disqualifiedCandidatesCount }}
    </div>
  }
  @if (fieldsVisibilityMap.hires && record.hiredCandidatesCount) {
    <div class="counter">
      <rt-icon name="hired" margin-right-small-xx />
      {{ record.hiredCandidatesCount }}
    </div>
  }
</div>
@if (isHovered) {
  <div class="actions">
    <rt-icon-button
      size="small"
      variant="plain"
      [iconName]="record.followed ? 'bookmark' : 'bookmark-border'"
      [rtTooltip]="
        (record.followed ? 'app.follow_dropdown.unfollow' : 'app.follow_dropdown.follow')
          | translate
      "
      (click)="onFollow($event)"
    />
    @if (isInternalOrPublished && (canViewAcquisition$ | async)) {
      <rt-icon-button
        size="small"
        variant="plain"
        iconName="bullhorn"
        [rtTooltip]="'app.common.promote' | translate"
        (click)="onAcquisition($event)"
      />
    }
    @if (canManageJobs$ | async) {
      <rt-icon-button
        size="small"
        variant="plain"
        iconName="content-copy"
        [rtTooltip]="'app.offers.duplicate' | translate"
        (click)="onDuplicate($event)"
      />
      <rt-icon-button
        size="small"
        variant="plain"
        iconName="edit"
        [rtTooltip]="'app.common.edit' | translate"
        (click)="onEdit($event)"
      />
      @if (record.status !== OfferStatus.Archived) {
        <rt-icon-button
          size="small"
          variant="plain"
          iconName="archive"
          [rtTooltip]="'app.offers.archive' | translate"
          (click)="onArchive($event)"
        />
      }
      @if (record.status === OfferStatus.Archived) {
        <rt-icon-button
          size="small"
          variant="plain"
          iconName="unarchive"
          [rtTooltip]="'app.offers.unarchive' | translate"
          (click)="onUnarchive($event)"
        />
      }
      @if (record.status === OfferStatus.Archived || record.status === OfferStatus.Draft) {
        <rt-icon-button
          size="small"
          variant="plain"
          iconName="delete"
          [rtTooltip]="'app.common.delete' | translate"
          (click)="onDelete($event)"
        />
      }
    }
  </div>
}
